/**
 * Whether the server has the assistant configured. Read once from
 * /api/config, so the UI hides itself entirely rather than offering a feature
 * that 503s.
 */
import { useSyncExternalStore } from "react";

let enabled = false;
let loaded = false;
const listeners = new Set<() => void>();

function emit(): void {
  for (const l of listeners) l();
}

export function loadAgentConfig(): void {
  if (loaded) return;
  loaded = true;
  void fetch("/api/config")
    .then((r) => (r.ok ? (r.json() as Promise<{ agentEnabled?: boolean }>) : null))
    .then((cfg) => {
      enabled = !!cfg?.agentEnabled;
      emit();
    })
    .catch(() => {});
}

export function useAgentEnabled(): boolean {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => enabled,
    () => false,
  );
}
